// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 2/21/2024 9:30:35 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import {
  ApplicationTypeEnum,
  CompanyStatusTypeEnum,
  CultureTypeEnum,
  EmailTypeEnum,
  PersonTypeEnum,
  SecurityRoleTypeEnum,
  TimeZoneTypeEnum,
} from '../schema/Schema';
import { Post } from '../../../httpClient';

export enum GetSecurityRoleListEnum {
  invalidCompanyId = 0,
}

export enum AddPersonToManagerEnum {
  departmentNotAvailable = 0,
  departmentNotFound = 1,
  invalidDepartmentId = 2,
  invalidUserId = 3,
}

export enum GetUserListEnum {
  takeLessThen1 = 0,
  takeMoreThen100 = 1,
  skipLessThan0 = 2,
  invalidFilters = 3,
  invalidSecurityRoleId = 4,
}

export enum GetUserEnum {
  invalidUserId = 0,
}

export enum GetSecurityRoleEnum {
  bothIdAndTypeUnassigned = 0,
  bothIdAndTypeAssigned = 1,
}

export enum MaintainPersonSecurityRoleEnum {}

export enum PersistUserEnum {
  userExistsWithEmail = 0,
}

export enum PersistSecurityRoleEnum {}

export enum GetSecurityAccountListEnum {}

export enum ResetToDefaultPermissionEnum {
  invalidSecurityRoleId = 0,
  invalidSecurityRoleType = 1,
}

export enum PersistUserPermissionEnum {
  invalidSecurityRoleId = 0,
  invalidUserId = 1,
}

export enum MaintainUserEnum {
  invalidUserId = 0,
}

export enum CreateEmployeeProfileEnum {
  invalidUserId = 0,
}

export enum GetAdmistratorListEnum {}

export enum TransferOwnershipEnum {
  invalidUserId = 0,
  invalidNewUserId = 1,
  bothDisableAndNewRoleAssigned = 2,
  bothDisableAndNewRoleUassigned = 3,
}

export enum GetUserListSortEnum {
  name = 0,
  employmentType = 1,
  email = 2,
  lastLoggedIn = 3,
  department = 4,
}

export enum GetAdminListSortEnum {
  name = 0,
  role = 1,
}

export enum GetOptInEnum {
  invalidOptInKey = 0,
}

export enum OptInEnum {
  invalidOptInKey = 0,
  passwordInvalid = 1,
  userNotFound = 2,
  optinKeyNotValid = 3,
  optInKeyExpired = 4,
  authenticationStateInvalid = 5,
}

export enum PersistCultureEnum {
  securityAccountIdLessThan1 = 0,
}

export enum ChangePasswordEnum {
  usernameEmpty = 0,
  newPasswordEmpty = 1,
  existingPasswordEmpty = 2,
  minimum8Letters = 3,
  atleast1Uppercase = 4,
  atleast1Lowercase = 5,
  atleast1Number = 6,
  atleast1SpecialCharacter = 7,
}

export enum MaintainTwoFactorAuthorizationEnum {}

export enum VerifySmsCodeEnum {
  emptyPhone = 0,
  emptyCode = 1,
  incorrectCode = 2,
  expiredCode = 3,
  invalidVisitorId = 4,
}

export enum ChangeEmailEnum {}

export enum ResetPasswordEnum {
  invalidKey = 0,
  passwordInvalid = 1,
  userNotFound = 2,
  keyNotValid = 3,
  keyExpired = 4,
  smsCodeInvalid = 5,
  smsCodeExpired = 6,
}

export enum GetInactiveUserListEnum {}

export enum GetIpAddressStatisticsListEnum {}

export enum GerEmployeeListEnum {}

export enum CloseCompanyAccountEnum {
  invalidCompanyId = 0,
}

export enum ValidateEmailEnum {
  userExistsWithEmail = 0,
  userExistsWithDifferentEmailType = 1,
}

export enum GetSignatoryListEnum {}

export interface GetSecurityRoleListRequestInterface {
  includeUserCount: boolean;
  companyId?: number;
}

export interface GetSecurityRoleListResponseInterface {
  securityRoleList: Array<SecurityRoleInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SecurityRoleInterface {
  id: number;
  name: string;
  description: string;
  userCount: number;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
  hasCustomization: boolean;
  permissionCategoryList: Array<PermissionCategoryInterface>;
  userList: Array<UserInterface>;
  getAlfredSecurityRoleListResponse: GetAlfredSecurityRoleListResponseInterface;
}

export interface UserInterface {
  id: number;
  email: string;
  lastLogin?: string;
  firstName: string;
  lastName: string;
  isEmployee: boolean;
  isDisabled: boolean;
  isEditable: boolean;
  personType: PersonTypeEnum;
  securityRoleTypeList: Array<SecurityRoleTypeEnum>;
  phoneNumber: string;
  cultureType: CultureTypeEnum;
  companyId: number;
  personId: number;
  twoFactorEnabled: boolean;
  countryType: string;
  passwordAssignmentDate: string;
  profileDocumentId?: number;
  isFirstTimeLogin: boolean;
  hasChangedPassword: boolean;
  primaryJobTitle: string;
  hasMultipleAssociation: boolean;
  isPayrollApprover: boolean;
  departmentList: Array<DepartmentInterface>;
  stateList: Array<StateInterface>;
}

export interface PermissionInterface {
  id: number;
  name: string;
  description: string;
  isRead: boolean;
  isReadWrite: boolean;
  isSelected: boolean;
  isSubmit: boolean;
  isApprove: boolean;
}

export interface PermissionCategoryInterface {
  id: number;
  name: string;
  description: string;
  permissionSubCategoryList: Array<PermissionSubCategoryInterface>;
}

export interface DepartmentInterface {
  id: number;
  name: string;
}

export interface AddPersonToManagerRequestInterface {
  userId: number;
  departmentIdList: Array<number>;
  stateIdList?: Array<number>;
}

export interface AddPersonToManagerResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetUserListRequestInterface {
  securityRoleId: number;
  take: number;
  skip: number;
  companyId?: number;
  securityRoleType: SecurityRoleTypeEnum;
  includeRole: boolean;
  includeEditAccess: boolean;
  includeDepartrment: boolean;
  filterByEmail: boolean;
  emailContains: string;
  includeDisabled: boolean;
  filterByName: boolean;
  nameContains: string;
  filterByPersonType: boolean;
  includeEmployee: boolean;
  includeNonEmployee: boolean;
  includeContractor: boolean;
  sortColumnType: GetUserListSortEnum;
  sortAscending: boolean;
  includeEmployeeAdmin: boolean;
  includeEmployeeWithAccess: boolean;
  includeCurrentUser: boolean;
}

export interface GetUserListResponseInterface {
  totalCount: number;
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetUserRequestInterface {
  userId: number;
  includeSecurityRoleList: boolean;
  includePermission: boolean;
  securityRoleType?: SecurityRoleTypeEnum;
  applicationType: ApplicationTypeEnum;
}

export interface GetUserResponseInterface {
  user: UserInterface;
  securityRoleList: Array<SecurityRoleInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetSecurityRoleRequestInterface {
  securityRoleId: number;
  includeUserList: boolean;
  includePermissionList: boolean;
  securityRoleType: SecurityRoleTypeEnum;
  companyId: number;
  isPartnerRole: boolean;
}

export interface GetSecurityRoleResponseInterface {
  isDepartmentAvailable: boolean;
  securityRole: SecurityRoleInterface;
  validationResults: ValidationResultsInterface;
}

export interface MaintainPersonSecurityRoleRequestInterface {
  userId: number;
  securityRoleId: number;
  securityRoleType: SecurityRoleTypeEnum;
  assign: boolean;
  unassign: boolean;
  stateIdList?: Array<number>;
}

export interface MaintainPersonSecurityRoleResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistUserRequestInterface {
  personId: number;
  emailAddress: string;
  firstName: string;
  lastName: string;
  securityRoleType: SecurityRoleTypeEnum;
  password: string;
  stateIdList?: Array<number>;
  departmentIdList: Array<number>;
  inviteToEmployeePortal: boolean;
  skipResetPasswordEmail: boolean;
  inviteToSelfOnboarding: boolean;
  tenantId?: number;
}

export interface PersistUserResponseInterface {
  userId: number;
  validationResults: ValidationResultsInterface;
}

export interface PersistSecurityRoleRequestInterface {
  securityRoleId: number;
  keepCustomization: boolean;
  isPartnerRole: boolean;
  securityRole: SecurityRoleInterface;
}

export interface PersistSecurityRoleResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetSecurityAccountListRequestInterface {
  take: number;
  skip: number;
  personUserList: Array<PersonUserInterface>;
}

export interface GetSecurityAccountListResponseInterface {
  securityAccountList: Array<SecurityAccountInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SecurityAccountInterface {
  id: number;
  lastLoginDateTime?: string;
  personId: number;
  companyId: number;
}

export interface PersonUserInterface {
  personId: number;
  userId: number;
}

export interface PermissionSubCategoryInterface {
  id: number;
  name: string;
  description: string;
  parentSubCategoryId?: number;
  permissionList: Array<PermissionInterface>;
}

export interface ResetToDefaultPermissionRequestInterface {
  securityRoleId: number;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface ResetToDefaultPermissionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistUserPermissionRequestInterface {
  userId: number;
  securityRoleType: SecurityRoleTypeEnum;
  permissionCategoryList: Array<PermissionCategoryInterface>;
}

export interface PersistUserPermissionResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainUserRequestInterface {
  userId: number;
  enable: boolean;
  disable: boolean;
  fromEmployee: boolean;
  fromEmployer: boolean;
}

export interface MaintainUserResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface CreateEmployeeProfileRequestInterface {
  userId: number;
}

export interface CreateEmployeeProfileResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetAdministratorListRequestInterface {
  includeAccountingAdmin: boolean;
  filterByName: boolean;
  nameContains: string;
  includeDisabled: boolean;
  sortColumnType: GetAdminListSortEnum;
  sortAscending: boolean;
  companyId: number;
  includeJobTitle: boolean;
  includeTwoFactorStatus: boolean;
  filterByPayrollPermission: boolean;
}

export interface GetAdministratorListResponseInterface {
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TransferOwnershipRequestInterface {
  userId: number;
  newOwnerUserId: number;
  disable: boolean;
  securityRoleType: SecurityRoleTypeEnum;
  departmentIdList: Array<number>;
  stateIdList?: Array<number>;
  companyId?: number;
}

export interface TransferOwnershipResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface StateInterface {
  id: number;
  name: string;
}

export interface GetOptInUserRequestInterface {
  optInKey: string;
}

export interface GetOptInUserResponseInterface {
  firstName: string;
  lastName: string;
  applicationType: ApplicationTypeEnum;
  validationResults: ValidationResultsInterface;
}

export interface OptInRequestInterface {
  optInKey: string;
  password: string;
}

export interface OptInResponseInterface {
  targetUrl: string;
  validationResults: ValidationResultsInterface;
}

export interface PersistCultureRequestInterface {
  timeZoneType: TimeZoneTypeEnum;
  cultureType: CultureTypeEnum;
  securityAccountId: number;
}

export interface PersistCultureResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ChangePasswordRequestInterface {
  username: string;
  newPassword: string;
  existingPassword: string;
}

export interface ChangePasswordResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainTwoFactorAuthorizationRequestInterface {
  enable: boolean;
  phoneNumber: string;
}

export interface MaintainTwoFactorAuthorizationResponseInterface {
  codeExpirationMinutes: number;
  validationResults: ValidationResultsInterface;
}

export interface VerifySmsCodeRequestInterface {
  phoneNumber: string;
  code: string;
  rememberDevice: boolean;
  visitorId: string;
}

export interface VerifySmsCodeResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ChangeEmailRequestInterface {
  oldEmail: string;
  newEmail: string;
  updateSecondaryEmail: boolean;
}

export interface ChangeEmailResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ResetPasswordRequestInterface {
  resetPasswordKey: string;
  password: string;
  validateKey: boolean;
  sendSmsCode: boolean;
  validateSmsCode: boolean;
  smsCode: string;
}

export interface ResetPasswordResponseInterface {
  twoFactorEnabled: boolean;
  phoneNumber: string;
  validationResults: ValidationResultsInterface;
}

export interface GetInactiveUserListRequestInterface {
  tenantId: number;
  take: number;
  skip: number;
}

export interface GetInactiveUserListResponseInterface {
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetIpAddressStatisticsListRequestInterface {
  companyId: number;
}

export interface GetIpAddressStatisticsListResponseInterface {
  ipAddressStatisticsList: Array<IpAddressStatisticsInterface>;
  validationResults: ValidationResultsInterface;
}

export interface IpAddressStatisticsInterface {
  ipAddress: string;
  attempts: number;
  failures: number;
  timeOfLastFailure: string;
  successiveAuthenticationFailures: number;
  userId?: number;
}

export interface GetEmployeeListRequestInterface {
  filterByName: boolean;
  nameContains: string;
  companyId: number;
}

export interface GetEmployeeListResponseInterface {
  personSummaryList: Array<PersonSummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersonSummaryInterface {
  userId?: number;
  email: string;
  lastLogin?: string;
  firstName: string;
  lastName: string;
  personType: PersonTypeEnum;
  phoneNumber: string;
  companyId: number;
  personId: number;
  countryType: string;
  isInvitedToEmployeePortal: boolean;
  stateList: Array<StateInterface>;
}

export interface CloseCompanyAccountRequestInterface {
  companyId: number;
  companyStatusType: CompanyStatusTypeEnum;
}

export interface CloseCompanyAccountResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ValidateEmailRequestInterface {
  emailAddress: string;
  emailType: EmailTypeEnum;
}

export interface ValidateEmailResponseInterface {
  isValid: boolean;
  validationResults: ValidationResultsInterface;
}

export interface GetSignatoryListRequestInterface {
  filterByName: boolean;
  nameContains: string;
  includeDisabled: boolean;
  sortColumnType: GetAdminListSortEnum;
  sortAscending: boolean;
  companyId: number;
}

export interface GetSignatoryListResponseInterface {
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetSecurityRoleTypeListRequestInterface {
  emailList: Array<string>;
}

export interface GetSecurityRoleTypeListResponseInterface {
  userSecurityRoleTypeList: Array<UserSecurityRoleTypeInterface>;
  validationResults: ValidationResultsInterface;
}

export interface UserSecurityRoleTypeInterface {
  email: string;
  securityRoleType: number;
}

export interface GetAlfredSecurityRoleListRequestInterface {}

export interface GetAlfredSecurityRoleListResponseInterface {
  securityRoleList: Array<SecurityRoleInterface>;
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export class SecurityAccessService {
  getSecurityRoleList(request: GetSecurityRoleListRequestInterface): Promise<GetSecurityRoleListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getSecurityRoleList', request);
  }

  addPersonToManager(request: AddPersonToManagerRequestInterface): Promise<AddPersonToManagerResponseInterface> {
    return Post('/AppCoreSecurityAccess/addPersonToManager', request);
  }

  getUserList(request: GetUserListRequestInterface): Promise<GetUserListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getUserList', request);
  }

  getUser(request: GetUserRequestInterface): Promise<GetUserResponseInterface> {
    return Post('/AppCoreSecurityAccess/getUser', request);
  }

  getSecurityRole(request: GetSecurityRoleRequestInterface): Promise<GetSecurityRoleResponseInterface> {
    return Post('/AppCoreSecurityAccess/getSecurityRole', request);
  }

  maintainPersonSecurityRole(
    request: MaintainPersonSecurityRoleRequestInterface
  ): Promise<MaintainPersonSecurityRoleResponseInterface> {
    return Post('/AppCoreSecurityAccess/maintainPersonSecurityRole', request);
  }

  persistUser(request: PersistUserRequestInterface): Promise<PersistUserResponseInterface> {
    return Post('/AppCoreSecurityAccess/persistUser', request);
  }

  persistSecurityRole(request: PersistSecurityRoleRequestInterface): Promise<PersistSecurityRoleResponseInterface> {
    return Post('/AppCoreSecurityAccess/persistSecurityRole', request);
  }

  getSecurityAccountList(
    request: GetSecurityAccountListRequestInterface
  ): Promise<GetSecurityAccountListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getSecurityAccountList', request);
  }

  resetToDefaultPermission(
    request: ResetToDefaultPermissionRequestInterface
  ): Promise<ResetToDefaultPermissionResponseInterface> {
    return Post('/AppCoreSecurityAccess/resetToDefaultPermission', request);
  }

  persistUserPermission(
    request: PersistUserPermissionRequestInterface
  ): Promise<PersistUserPermissionResponseInterface> {
    return Post('/AppCoreSecurityAccess/persistUserPermission', request);
  }

  maintainUser(request: MaintainUserRequestInterface): Promise<MaintainUserResponseInterface> {
    return Post('/AppCoreSecurityAccess/maintainUser', request);
  }

  createEmployeeProfile(
    request: CreateEmployeeProfileRequestInterface
  ): Promise<CreateEmployeeProfileResponseInterface> {
    return Post('/AppCoreSecurityAccess/createEmployeeProfile', request);
  }

  getAdministratorList(request: GetAdministratorListRequestInterface): Promise<GetAdministratorListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getAdministratorList', request);
  }

  transferOwnership(request: TransferOwnershipRequestInterface): Promise<TransferOwnershipResponseInterface> {
    return Post('/AppCoreSecurityAccess/transferOwnership', request);
  }

  getOptInUser(request: GetOptInUserRequestInterface): Promise<GetOptInUserResponseInterface> {
    return Post('/AppCoreSecurityAccess/getOptInUser', request);
  }

  optIn(request: OptInRequestInterface): Promise<OptInResponseInterface> {
    return Post('/AppCoreSecurityAccess/optIn', request);
  }

  persistCulture(request: PersistCultureRequestInterface): Promise<PersistCultureResponseInterface> {
    return Post('/AppCoreSecurityAccess/persistCulture', request);
  }

  changePassword(request: ChangePasswordRequestInterface): Promise<ChangePasswordResponseInterface> {
    return Post('/AppCoreSecurityAccess/changePassword', request);
  }

  maintainTwoFactorAuthorization(
    request: MaintainTwoFactorAuthorizationRequestInterface
  ): Promise<MaintainTwoFactorAuthorizationResponseInterface> {
    return Post('/AppCoreSecurityAccess/maintainTwoFactorAuthorization', request);
  }

  verifySmsCode(request: VerifySmsCodeRequestInterface): Promise<VerifySmsCodeResponseInterface> {
    return Post('/AppCoreSecurityAccess/verifySmsCode', request);
  }

  changeEmail(request: ChangeEmailRequestInterface): Promise<ChangeEmailResponseInterface> {
    return Post('/AppCoreSecurityAccess/changeEmail', request);
  }

  resetPassword(request: ResetPasswordRequestInterface): Promise<ResetPasswordResponseInterface> {
    return Post('/AppCoreSecurityAccess/resetPassword', request);
  }

  getInactiveUserList(request: GetInactiveUserListRequestInterface): Promise<GetInactiveUserListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getInactiveUserList', request);
  }

  getIpAddressStatisticsList(
    request: GetIpAddressStatisticsListRequestInterface
  ): Promise<GetIpAddressStatisticsListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getIpAddressStatisticsList', request);
  }

  getEmployeeList(request: GetEmployeeListRequestInterface): Promise<GetEmployeeListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getEmployeeList', request);
  }

  closeCompanyAccount(request: CloseCompanyAccountRequestInterface): Promise<CloseCompanyAccountResponseInterface> {
    return Post('/AppCoreSecurityAccess/closeCompanyAccount', request);
  }

  validateEmail(request: ValidateEmailRequestInterface): Promise<ValidateEmailResponseInterface> {
    return Post('/AppCoreSecurityAccess/validateEmail', request);
  }

  getSignatoryList(request: GetSignatoryListRequestInterface): Promise<GetSignatoryListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getSignatoryList', request);
  }

  getSecurityRoleTypeList(
    request: GetSecurityRoleTypeListRequestInterface
  ): Promise<GetSecurityRoleTypeListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getSecurityRoleTypeList', request);
  }

  getAlfredSecurityRoleList(
    request: GetAlfredSecurityRoleListRequestInterface
  ): Promise<GetAlfredSecurityRoleListResponseInterface> {
    return Post('/AppCoreSecurityAccess/getAlfredSecurityRoleList', request);
  }
}

export default new SecurityAccessService();
